import { getClickId } from '$lib/PageSections/Forms/formUtils';

export function getQuoraClickId(url) {
	return getClickId(url, 'qclid');
}
